import moment from 'moment';

export const HEADER = [
  {title:"No."},
  {title:"Created At"},
  {title:"Contact Details"},
  {title:"Banks"},
  {title:"Lead Type"},
  {title:"Status"},
  {title:"Action"},
];

export const DATA_TYPES = [
  {eventKey: "all", label: "All", convert: value => value},
  {eventKey: "created_at", label: "Created Date", convert: value => moment(value).format('D MMMM YYYY')},
  {eventKey: "checkID", label: "Check ID", convert: value => value},
  {eventKey: "email", label: "Email", convert: value => value},
  {eventKey: "name", label: "Full Name", convert: value => value},
  {eventKey: "mobile", label: "Mobile Number", convert: value => value.prefix && value.suffix ? `${value.prefix + value.suffix}` : `${value}`},
  {eventKey: "nric", label: "NRIC", convert: value => value},
  {eventKey: "status", label: "Status", convert: value => value},
  {eventKey: "leadType", label: "Lead Type", convert: value => value},
  {eventKey: "leadID", label: "Lead ID", convert: value => value},
  {eventKey: "ownershipType", label: "Ownership Type", convert: value => value},
];

export const SORT_DATA_TYPES = [
  {eventKey: "newestDate", label: "Date: Newest", convert: value => value},
  {eventKey: "oldestDate", label: "Date: Oldest", convert: value => value},
  {eventKey: "ascName", label: "Name: Ascending", convert: value => value},
  {eventKey: "descName", label: "Name: Descending", convert: value => value},
];



// WEBPACK FOOTER //
// ./src/const/leadsLists.js